<template>
  <div class="bs-loading">
    <div class="loading-message">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BSLoading',
}
</script>

<style lang="scss">
@keyframes spinner {
  to {
    transform: rotate(360deg);
  }
}
.bs-loading {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: black;
  color: white;
  .loading-message {
    width: auto;
    text-align: center;
    position: relative;
    &:before {
      content: '';
      box-sizing: border-box;
      position: absolute;
      bottom: 200%;
      left: 50%;
      width: 2rem;
      height: 2rem;
      margin-top: -1rem;
      margin-left: -1rem;
      border-radius: 50%;
      border: 2px solid white;
      border-top-color: goldenrod;
      animation: spinner 0.6s linear infinite;
    }
  }
}
</style>
